import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { AuthComponent } from './auth/auth.component';

const routes: Routes = [
  {
	path: '',
	component: AuthComponent,
    data: {
      title: 'Authentication',
      status: false
    },
    children: [
		{
			path: '',
			redirectTo: 'login',
			pathMatch: 'full',
		  },	
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'forgot',
        loadChildren: () => import('./forgot/forgot.module').then(m => m.ForgotModule)
	  },
      {
        path: 'reset',
        loadChildren: () => import('./reset/reset.module').then(m => m.ResetModule)
	  }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
